import { LoaderCircle, X } from "lucide-react";
import { t } from "../../i18n";

export function RenameDialog({
  title,
  busy,
  onChange,
  onCancel,
  onConfirm,
}: {
  title: string;
  busy: boolean;
  onChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/50 p-4"
      onMouseDown={(event) =>
        event.target === event.currentTarget && onCancel()
      }
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="rename-title"
        className="w-full max-w-md rounded-2xl border border-stone-200 bg-white p-5 shadow-2xl dark:border-white/10 dark:bg-stone-900"
      >
        <div className="flex items-center justify-between">
          <h2 id="rename-title" className="font-bold">
            {t("Rename chat")}
          </h2>
          <button
            type="button"
            className="button p-1.5"
            onClick={onCancel}
            disabled={busy}
          >
            <X size={16} />
          </button>
        </div>
        <input
          autoFocus
          value={title}
          maxLength={160}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") onConfirm();
            if (event.key === "Escape") onCancel();
          }}
          className="mt-4 w-full rounded-xl border border-stone-200 bg-white px-3 py-2.5 text-sm outline-none focus:border-lumen-400 dark:border-white/10 dark:bg-white/5"
        />
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            className="button border border-stone-200 dark:border-white/10"
            onClick={onCancel}
            disabled={busy}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="button-primary"
            onClick={onConfirm}
            disabled={busy || !title.trim()}
          >
            {busy && <LoaderCircle className="animate-spin" size={15} />}{" "}
            {t("Save")}
          </button>
        </div>
      </div>
    </div>
  );
}
